import { LocationConditionEnum } from '@/constants/enum';
import CityCondition from '@/pages/Settings/Components/EstimateRules/components/CURule/components/DisplayConditions/components/CityCondition';
import CountryCondition from '@/pages/Settings/Components/EstimateRules/components/CURule/components/DisplayConditions/components/CountryCondition';
import ProvinceCondition from '@/pages/Settings/Components/EstimateRules/components/CURule/components/DisplayConditions/components/ProvinceCondition';
import ZipcodeCondition from '@/pages/Settings/Components/EstimateRules/components/CURule/components/DisplayConditions/components/ZipcodeCondition';
import { IConditionValue, IItemCondition, ILocationCondition, RelationCondition } from '@/types/newSetup.type';
import { Badge } from '@shopify/polaris';
import React from 'react';

interface IProps {
  data: ILocationCondition;
  onChange: (key: IItemCondition['type'] | ILocationCondition['type']) => (value: IConditionValue[] | null) => void;
  onRemove: (condition: IItemCondition['type'] | ILocationCondition['type']) => void;
  isInCheckout?: boolean;
  typeRelationOfItem?: RelationCondition;
  isShowBadge?: boolean;
}

const LocationCheckoutConditionItem = ({ data, onChange, onRemove, isInCheckout, typeRelationOfItem, isShowBadge }: IProps) => {
  const renderLocationItem = () => {
    switch (data.type) {
      case LocationConditionEnum.Country:
        return (
          <React.Fragment key={data.type}>
            <div className="mt-16" key={data.type}>
              <CountryCondition
                onDismiss={() => {
                  onRemove(data.type);
                }}
                data={data?.value || []}
                handleChange={(value) => {
                  onChange(data.type)(value);
                }}
                isInCheckout={isInCheckout}
              />
            </div>
          </React.Fragment>
        );
      case LocationConditionEnum.Zipcode:
        return (
          <React.Fragment key={data.type}>
            <div className="mt-16" key={data.type}>
              <ZipcodeCondition
                onDismiss={() => {
                  onRemove(data.type);
                }}
                isInCheckout={isInCheckout}
              />
            </div>
          </React.Fragment>
        );
      case LocationConditionEnum.City:
        return (
          <React.Fragment key={data.type}>
            <div className="mt-16" key={data.type}>
              <CityCondition
                onDismiss={() => {
                  onRemove(data.type);
                }}
                isInCheckout={isInCheckout}
              />
            </div>
          </React.Fragment>
        );
      case LocationConditionEnum.State:
        return (
          <React.Fragment key={data.type}>
            <div className="mt-16" key={data.type}>
              <ProvinceCondition
                onDismiss={() => {
                  onRemove(data.type);
                }}
                isInCheckout={isInCheckout}
              />
            </div>
          </React.Fragment>
        );
      default:
        return null;
    }
  };
  return (
    <div className="main-condition-container mt-12">
      {renderLocationItem()}
      {isShowBadge && typeRelationOfItem && (
        <div className="mt-16">
          <Badge tone="info">{typeRelationOfItem.toLocaleUpperCase()}</Badge>
        </div>
      )}
    </div>
  );
};

export default LocationCheckoutConditionItem;
